import { Component, Host, Input } from '@angular/core';
import {  AbstractControl, FormGroup } from '@angular/forms';
import { ValidationService } from '../../services';

/* tslint:disable */
@Component({
	selector: 'control-messages',
	templateUrl: "./control-messages.html",
	styles: [require("./control-messages.scss")]
})
export class ControlMessages {
	controlName: string;
	@Input() control: AbstractControl
	@Input() customMessage: string
	@Input() visibleIfUntouched: boolean

	get errorMessage() {
		if (this.control.errors && (this.getTouchedProperty(this.control) || this.visibleIfUntouched)) {
			if (this.customMessage) return this.customMessage
			for (let errorName in this.control.errors) {
				return ValidationService.getValidatorErrorMessage(errorName);
			}
		}
		return null;
	}

	private getTouchedProperty(control: AbstractControl) {
		if(control instanceof FormGroup) {
			let controls = Object.keys(control.controls)
			let touched: boolean = false;
			controls.forEach(element => {
				if (control.controls[element].touched)	touched = true
			});
			return touched;
		} else {
			return control.touched
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/control-messages/control-messages.component.ts